import { render, staticRenderFns } from "./StyleEditTabPackaging.vue?vue&type=template&id=6173e825&"
import script from "./StyleEditTabPackaging.vue?vue&type=script&lang=js&"
export * from "./StyleEditTabPackaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports